import axiosInstance from './axiosInstance';

interface ControlItem {
  status: boolean;
  value: string | null;
}

interface ControlsInitResponse {
  [key: string]: ControlItem;
}

interface UpdateControlRequest {
  status?: boolean;
  value?: string | null;
  reason?: string;
}

interface ControlResponse {
  key: string;
  name: string;
  description: string;
  is_active: boolean;
  status: boolean;
  value: string | null;
  updated_at: Date | null;
  updated_by: number | null;
}

// Get all active controls for initialization (cached endpoint)
export const getControlsInit = async (): Promise<ControlsInitResponse> => {
  const response = await axiosInstance.get('/controls/init');
  return response.data;
};

// Update a specific control (admin only)
export const updateControl = async (
  controlKey: string,
  data: UpdateControlRequest,
): Promise<{ [key: string]: ControlResponse }> => {
  const response = await axiosInstance.put(`/controls/${controlKey}`, data);
  return response.data;
};

// Get controls with optional filtering
export const getControls = async (params?: {
  keys?: string;
  includeInactive?: boolean;
}): Promise<{ [key: string]: ControlResponse }> => {
  const response = await axiosInstance.get('/controls', { params });
  return response.data;
};
